module.exports = __webpack_public_path__ + "static/img/why_us_channel.a98003a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/why_us_channel.png
// module id = b7mJ
// module chunks = 8